import React from "react"

import { Popup } from "react-map-gl/mapbox"

import {
  LocationIdentity,
  MapCard,
  MapCardLabel,
  RouteIdentity,
} from "@/components/collections/monitoring/MapOverlayCard"
import { formatRouteCount, uniqueRoutesFrom } from "@/lib/mapOverlay"
import { Route } from "@/types/collections"

import { type LocationEntry } from "./LocationPin"

interface LocationPopupProps {
  lat: number
  lng: number
  entries: LocationEntry[]
  onClose: () => void
  onRouteChoose: (route: Route) => void
}

const LocationPopup: React.FC<LocationPopupProps> = ({
  lat,
  lng,
  entries,
  onClose,
  onRouteChoose,
}) => (
  <Popup
    longitude={lng}
    latitude={lat}
    anchor="bottom"
    onClose={onClose}
    closeOnClick={true}
    closeButton={false}
    /* Mapbox caps popups at 240px by default, which would clip the card. */
    maxWidth="none"
    className="stop-popup z-[100] [&_.mapboxgl-popup-content]:rounded-lg [&_.mapboxgl-popup-content]:bg-transparent [&_.mapboxgl-popup-content]:p-0 [&_.mapboxgl-popup-content]:shadow-none [&_.mapboxgl-popup-tip]:!hidden"
  >
    <MapCard size="md" className="antialiased">
      <div className="p-3">
        <LocationIdentity size="md" name={entries[0].stop.name} address={entries[0].stop.address} />
      </div>
      <div className="border-t border-palette-jungleGreen100 px-3 pb-3 pt-2.5">
        <MapCardLabel>
          Serviced by {formatRouteCount(uniqueRoutesFrom(entries).length)}
        </MapCardLabel>
        <div className="mt-2 max-h-[228px] space-y-1.5 overflow-y-auto">
          {uniqueRoutesFrom(entries).map((route) => (
            <button
              key={route.id}
              type="button"
              onClick={() => onRouteChoose(route)}
              className="block w-full rounded-lg border border-amber-200 bg-amber-50 px-2.5 py-2 text-left transition-colors hover:border-amber-300 hover:bg-amber-100"
            >
              <RouteIdentity size="md" code={route.code} driverName={route.driverName} />
            </button>
          ))}
        </div>
      </div>
    </MapCard>
  </Popup>
)

export default LocationPopup
